import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);
    json['end_local_time'] = json['end_local_time'] === '00:00' ? '24:00' : json['end_local_time'];
    return json;
  }
});